import ScrollMagic from 'scrollmagic';
//import { TweenMax, TimelineMax } from "gsap"; // Also works with TweenLite and TimelineLite
//import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
//ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

export default function (elements) {
    //Create controller
    const controller = new ScrollMagic.Controller();
    const stickyItems = elements.stickyItemsWrap.querySelectorAll('.dr-sticky-scroll-element');
    const stickyElement = elements.stickyItemsWrap.querySelector('.dr-sticky-scroll-element');

    let windowWidth, windowHeight;
    updateSizes();
    const headerHeight = 80;
    let pinTriggerHook = getPinTriggerHook()


    //Create variables array
    const scenes = [];
    let triggerItemsHeight = [];

    function updateSizes() {
        windowWidth = window.innerWidth;
        windowHeight = window.innerHeight;
    }

    function pauseAllVideos() {
        if (elements.videoIdList && elements.videoIdList.length) {
            elements.videoIdList.forEach(video => {
                if (Wistia.api(`video-container-${video}`).state() === 'playing') {
                    console.log(video + ' paused');
                    Wistia.api(`video-container-${video}`).pause()
                }
            })
        }
    }

    function showBlock(index) {
        stickyItems[index].classList.add('is-active');
        elements.triggerItems[index].classList.add('is-active');
    }

    //Disable controller if window width < 768
    if (windowWidth < 768) {
        controller.enabled(false)
    }

    // Init first block from the very beginning
    showBlock(0)

    elements.triggerItems.forEach((triggerItem, index) => {
        //Push current element heights to array
        triggerItemsHeight.push(elements.triggerItems[index].offsetHeight)

        //Create scenes array with default parameters
        scenes.push(
            new ScrollMagic.Scene({
                triggerElement: triggerItem,
                triggerHook: 0.5,
                offset: -((elements.triggerItems[0].offsetHeight / 2) - 96), //96 - half padding
                duration: getDuration((getLastIndex(elements.triggerItems)), triggerItemsHeight, index)
            })
        )

        //Add methods to scene
        scenes[index]
            //.addIndicators({name: "container" + index}) //debug indicators
            .on("enter", function () {
                showBlock(index);
                if (elements.videoIdList && windowWidth > 768) {
                    if (typeof Wistia !== 'undefined') {
                        const videoId = elements.videoIdList[index];
                        if (videoId) {
                            let playInterval = setInterval(() => {
                                if (Wistia.api(`video-container-${videoId}`).state() === 'playing') {
                                    clearInterval(playInterval);
                                }
                                Wistia.api(`video-container-${elements.videoIdList[index]}`).play();
                            }, 300)
                        }
                    } else {
                        console.log('Wistia is not initialized');
                    }
                }
            })
            .on("leave", function (event) {
                if (windowWidth > 768) {
                    elements.triggerItems[index].classList.remove('is-active');
                    if ((index === 0) && event.scrollDirection === "FORWARD") {
                        stickyItems[index].classList.remove('is-active');
                    } else if ((index === 0) && event.scrollDirection === "REVERSE") {
                        stickyItems[index].classList.add('is-active')
                        elements.triggerItems[index].classList.add('is-active');
                    } else if (index === getLastIndex(stickyItems) && event.scrollDirection === "REVERSE") {
                        stickyItems[index].classList.remove('is-active');
                    } else if (index === getLastIndex(stickyItems) && event.scrollDirection === "FORWARD") {
                        elements.triggerItems[index].classList.add('is-active');
                        stickyItems[index].classList.add('is-active')
                    } else {
                        stickyItems[index].classList.remove('is-active');
                    }
                    if (elements.videoIdList) {
                        if (typeof Wistia !== 'undefined') {
                            pauseAllVideos()
                        }
                    }
                }
            })
            .addTo(controller)
    })

    //Scene for sticky container
    let pinScene = new ScrollMagic.Scene({
        triggerElement: elements.stickyScroll,
        triggerHook: pinTriggerHook,
        offset: 0,
        duration: elements.stickyScroll.offsetHeight - elements.triggerItems[getLastIndex(elements.triggerItems)].offsetHeight
    })
        .setPin(elements.stickyItemsWrap, {pushFollowers: true})
        //.addIndicators({name: "pin", indent: 200}) //debug indicators
        .addTo(controller)

    //Helper functions
    function getDuration(amount, items, index) {
        if (index === amount) {
            return items[index] + (items[index] / 2)
        } else {
            return items[index]
        }
    }

    function getPinTriggerHook() {
        //the sticky block in height should be centered on the screen
        return ((((windowHeight + headerHeight) - stickyElement.offsetHeight) / 2) / windowHeight)
    }

    function getLastIndex(items) {
        return items.length - 1
    }

    window.addEventListener('resize', () => {
        updateSizes();
        if (windowWidth > 768) {

            pinTriggerHook = getPinTriggerHook();
            triggerItemsHeight = [];

            // updating the duration of each scene
            elements.triggerItems.forEach((item, index) => {
                triggerItemsHeight.push(item.offsetHeight);
                scenes[index].duration(getDuration((getLastIndex(elements.triggerItems)), triggerItemsHeight, index));
            })
            pinScene.duration(elements.stickyScroll.offsetHeight - elements.triggerItems[getLastIndex(elements.triggerItems)].offsetHeight);
        }
    })
}
